import { withStateHandlers } from 'recompose';

import { QRCode as QRC } from './QRCode';

const enhance = withStateHandlers(
  { isVisible: false },
  {
    onToggle: ({ isVisible }) => () => ({ isVisible: !isVisible }),
  },
);

export const QRCode = enhance(QRC);
